import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as DemandbaseEnrichmentSelectors from 'app/modules/enrichment/demandbase/selectors'
import { fetchDemandbaseTargetingIndustries } from 'app/modules/enrichment/demandbase/actions'

import SelectFilter from '../SelectFilter'

const mapToOptions = (values) => !!values ? values.map(value => { return { label: value, value } }) : []

class DemandbaseIndustryFilter extends PureComponent {
  componentDidMount() {
    const { actions } = this.props

    actions.fetchDemandbaseTargetingIndustries();
  }

  render() {
    const { isSubIndustry, demandbaseIndustries, onUpdateCondition, activeFilter } = this.props
    const options = mapToOptions(demandbaseIndustries)
  
    return (
      <SelectFilter options={options} onUpdateCondition={onUpdateCondition} activeFilter={activeFilter} creatable={true}/>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchDemandbaseTargetingIndustries,
    },
    dispatch
  ),
})

const mapStateToProps = (state) => {
  return {
    demandbaseIndustries: DemandbaseEnrichmentSelectors.demandbaseTargetingIndustries(state),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DemandbaseIndustryFilter)


// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/Demandbase/DemandbaseIndustryFilter.js